import { useSWRInfinite } from 'swr'
import fetch from '../utils/fetch'
import qs from 'query-string'

const PAGE_SIZE = 100

export type SpecService = {
  group?: string // TBC
  name: string
  link: string
}

export type SpecType = {
  title: string
  description: string
  version: string
  hideServiceNames: boolean
  rels: SpecService[]
}

export type SpecsType =
  | {
      specs?: SpecType[]
      size?: number
      setSize?: (
        size: number | ((size: number) => number),
      ) => Promise<{ data: SpecType[]; nextPage: number }[] | undefined>
      isReachingEnd?: boolean
      isLoading?: boolean
    }
  | undefined

export type SpecsProps = SpecsType & {
  message?: string
  severity?: string
}

const useSpecs = (search?: string): SpecsProps => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getKey = (pageIndex: number, previousPageData: any): string | null => {
    if (previousPageData && (!previousPageData.data.length || previousPageData.nextPage < pageIndex)) return null

    return `/specs?${qs.stringify(
      {
        page: pageIndex + 1,
        per_page: PAGE_SIZE, // eslint-disable-line @typescript-eslint/camelcase
        search,
      },
      { skipEmptyString: true },
    )}`
  }
  const { data: res, error, size, setSize } = useSWRInfinite<{ data: SpecType[]; nextPage: number }>(getKey, fetch, {
    revalidateOnFocus: false,
  })

  const isLoadingInitialData = !res && !error
  const isEmpty = res?.[0]?.data?.length === 0

  if (error) {
    return { message: 'Unable to get the list of services.', severity: 'error' }
  }

  return {
    specs: res?.reduce((acc, req) => {
      acc.push(...req.data)
      return acc
    }, [] as SpecType[]),
    size,
    setSize,
    isLoading: isLoadingInitialData || (size > 0 && res && typeof res[size - 1] === 'undefined'),
    isReachingEnd: isEmpty || (res && res[res.length - 1]?.data?.length < PAGE_SIZE),
  }
}

export default useSpecs
